import React, { createContext, useContext } from 'react';

const AuthBrandingContext = createContext({ branding: {} });

export const AuthBrandingProvider = ({ branding = {}, children }) => {
	return (
		<AuthBrandingContext.Provider value={{ branding }}>
			{children}
		</AuthBrandingContext.Provider>
	);
};

export const useAuthBranding = () => useContext(AuthBrandingContext);
